import { Suspense } from 'react';

import { createRoot } from 'react-dom/client';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import themes from 'styles/themes';

import { shouldForwardProp } from 'containers/common/Providers/AppThemeProvider/ThemeProvider.utils';

import App from './App';
import reportWebVitals from './reportWebVitals';

import 'react-datepicker/dist/react-datepicker.css';
import 'reflect-metadata';
import 'requestidlecallback-polyfill';
import 'i18n';

import 'utils/date';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

// Covers the boot loader and error screen, which render before AppThemeProvider's own StyleSheetManager.
root.render(
  <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
    <ThemeProvider theme={themes.main}>
      <Suspense fallback={<></>}>
        <App />
      </Suspense>
    </ThemeProvider>
  </StyleSheetManager>,
);

reportWebVitals();
